<template>
  <AlertDialogRoot :open="showBanner">
    <AlertDialogPortal>
      <AlertDialogOverlay class="fixed inset-0 bg-black/60 z-[100]" />
      <AlertDialogContent
        class="fixed outline-none bottom-0 left-0 right-0 z-[100] bg-beige border-t-2 border-black shadow-[0_8px_0_0_rgba(0,0,0,0.1)] data-[state=open]:animate-overlay-show"
      >
        <div class="p-6 max-w-7xl mx-auto">
          <div class="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div class="flex-1 space-y-4">
              <AlertDialogTitle
                class="text-xl text-center lg:text-left leading-none font-bold text-black font-AeonikPro"
              >
                🍪 Help us improve your experience
              </AlertDialogTitle>
              <AlertDialogDescription class="text-sm text-black/80 leading-relaxed">
                We use cookies to provide you with the best possible experience, analyze how you use our site, and show
                you relevant content. By accepting all cookies, you're helping us make our platform better for everyone.
              </AlertDialogDescription>
              <div class="flex flex-wrap justify-center lg:justify-start gap-3 text-xs">
                <NuxtLink
                  to="https://app.termly.io/document/privacy-policy/e5344696-998a-41ba-b8b8-2b2a140d92bd"
                  class="text-black/70 hover:text-black underline underline-offset-2"
                  external
                  target="_blank"
                >
                  Privacy Policy
                </NuxtLink>
              </div>
            </div>

            <div class="flex flex-col gap-3 lg:flex-row lg:gap-4 lg:items-center">
              <button
                class="order-1 lg:order-3 px-8 py-4 text-base font-bold text-white bg-[#017735] rounded-xl hover:bg-[#015a29] transition-all duration-200 shadow-[0_4px_0_0_#015a29] hover:shadow-[0_2px_0_0_#015a29] hover:translate-y-[2px] font-Kontesa uppercase tracking-wide"
                @click="acceptAll"
              >
                Accept All & Continue
              </button>

              <div class="order-2 flex flex-col items-center gap-1">
                <CookiePreferencesButton
                  class="px-2 py-1 text-xs font-medium text-black/60 hover:text-black transition-colors underline underline-offset-2"
                >
                  Customize preferences
                </CookiePreferencesButton>
                <button
                  class="px-2 py-1 text-xs font-medium text-black/60 hover:text-black transition-colors underline underline-offset-2"
                  @click="acceptEssential"
                >
                  Essential cookies only
                </button>
              </div>
            </div>
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialogPortal>
  </AlertDialogRoot>
</template>

<script setup lang="ts">
const { showBanner, acceptAll, acceptEssential } = useCookieConsent();
</script>
